





























































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { Episode, Movie, TvShow } from "@/services/apiService/api.types";
import { Action, Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import SpatialNavigation from "spatial-navigation-js";
import LockIcon from "@/assets/svg/svg-settings/LockIcon.vue";
import {
  VodPageAction,
  VodPageGetter,
  VodPageMutation,
  VoDType
} from "@/components/VoD/types";
import { isEpisode, scrollToPage } from "@/helpers/utils";
import dayjs from "dayjs";
import Duration from "dayjs/plugin/duration";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { LocaleVodCard } from "@/plugins/i18n/types";
import {
  EpisodeDurationData,
  OverlayAction,
  OverlayMutation
} from "@/components/overlay/types";

@Component({
  components: { LockIcon }
})
export default class VoDCard extends Vue {
  @Ref("videoPlayer") readonly video!: HTMLVideoElement;
  @Prop() readonly vod!: TvShow | Movie | Episode;
  @Prop({ default: 0 }) readonly sliderIndex?: number;
  @Prop() readonly customId?: string;
  @Prop({ default: 0 }) readonly overlaySliderIndex?: number;

  @Mutation(OverlayMutation.SetActiveVodItem, {
    namespace: Namespace.Overlay
  })
  setActiveVodItem!: (vod: Movie | Episode | null) => void;

  @Action(VodPageAction.UpdateClosePlayer, {
    namespace: Namespace.Vod
  })
  updateClosePlayer!: (status: boolean) => void;

  @Action(OverlayAction.UpdateEpisodeDuration, {
    namespace: Namespace.Overlay
  })
  updateEpisodeDuration!: (episodeData: EpisodeDurationData) => void;

  @Mutation(VodPageMutation.setInfoModalVodId, {
    namespace: Namespace.Vod
  })
  setInfoModalVodId!: (vodId: number) => void;

  @Mutation(VodPageMutation.setShowVodInfoModal, {
    namespace: Namespace.Vod
  })
  setShowVodInfoModal!: (show: boolean) => void;

  @Mutation(VodPageMutation.setRefocusCardId, {
    namespace: Namespace.Vod
  })
  setRefocusCardId!: (cardId: string) => void;

  @Mutation(VodPageMutation.setCardControls, {
    namespace: Namespace.Vod
  })
  setControlsActive!: (cardControls: boolean) => void;

  @Mutation(VodPageMutation.setPlayedEpisodePos, {
    namespace: Namespace.Vod
  })
  setPlayedEpisodePos!: (
    pos:
      | {
          slideIndex: number;
          sliderIndex: number;
        }
      | undefined
  ) => void;

  @Mutation(VodPageMutation.setShowEpisodeInfoModal, {
    namespace: Namespace.Vod
  })
  setShowEpisodeInfoModal!: (show: boolean) => void;

  @Mutation(VodPageMutation.SetActiveEpisode, {
    namespace: Namespace.Vod
  })
  setActiveEpisode!: (episode: Episode | null) => void;

  @Getter(VodPageGetter.GetShowVodInfoModal, {
    namespace: Namespace.Vod
  })
  getShowVodInfoModal!: boolean;

  @Getter(VodPageGetter.GetViewedVodType, {
    namespace: Namespace.Vod
  })
  getViewedVodType!: VoDType;

  @Getter(VodPageGetter.GetClosePlayer, { namespace: Namespace.Vod })
  getClosePlayer!: boolean;

  @Getter(VodPageGetter.GetShowEpisodeInfoModal, { namespace: Namespace.Vod })
  getShowEpisodeInfoModal!: boolean;

  focusedControl = 0;
  episodeDuration = "";
  showControls = false;

  localeVodCard = LocaleVodCard;

  scrollFuncRef = scrollToPage;
  card: HTMLElement | null = null; //var that stores reference to this card in the DOM

  setDuration(): void {
    dayjs.extend(Duration);
    this.episodeDuration = dayjs
      .duration((this.video! as HTMLVideoElement).duration, "s")
      .format("H[h]:m[m]");
    this.updateEpisodeDuration({
      episodeId: this.vod.id,
      duration: this.episodeDuration
    });
  }

  mounted(): void {
    if (isEpisode(this.vod)) {
      this.card = document.getElementById(this.customId!);
    }
    if (this.card) {
      this.card.addEventListener("focusout", this.focusChanged);
    }
  }

  updateVodModalInfo(): void {
    this.setInfoModalVodId(this.vod.id);
    if (!this.getShowVodInfoModal) {
      this.setShowVodInfoModal(true);
      this.setRefocusCardId(this.vodCardId.replace(/\s/g, ""));
    }
  }

  get vodCardId(): string {
    return this.customId
      ? this.customId
      : this.getViewedVodType.replace(/\s/g, "") +
          this.vod.id +
          this.sliderIndex;
  }

  clickHandler(): void {
    if (!this.getShowVodInfoModal) {
      SpatialNavigation.focus(
        "#" + this.getViewedVodType + this.vod.id + this.sliderIndex
      );
      this.scrollFuncRef(
        this.getViewedVodType + this.vod.id + this.sliderIndex
      );
    }
    if (!isEpisode(this.vod)) {
      this.updateVodModalInfo();
    }

    if (
      isEpisode(this.vod) &&
      !this.getClosePlayer &&
      !this.getShowEpisodeInfoModal
    ) {
      this.setPlayedEpisodePos({ slideIndex: 0, sliderIndex: 0 });
      SpatialNavigation.focus("#" + this.customId);
      this.scrollFuncRef(this.customId!);
      this.openControls();
    }
  }

  get isEpisode(): boolean {
    return isEpisode(this.vod);
  }

  handleCardControls(event: KeyboardEvent): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_ENTER:
        if (!isEpisode(this.vod)) {
          this.updateVodModalInfo();
        }
        if (!this.showControls && isEpisode(this.vod)) {
          this.openControls();
          return;
        }
        switch (this.focusedControl) {
          case 0:
            this.handlePlay();
            break;
          case 1:
            this.handleInfo();
            break;
          case 2:
            break;
        }
        break;
      case KeySet.KEY_RIGHT:
        if (this.focusedControl < 2) {
          this.focusedControl++;
        }
        break;
      case KeySet.KEY_LEFT:
        if (this.focusedControl > 0) {
          this.focusedControl--;
        }
        break;
      case KeySet.KEY_BACK:
        this.showControls = false;
        this.setControlsActive(false);
        break;
    }
  }

  openControls(): void {
    this.showControls = true;
    this.setControlsActive(true);
  }

  focusChanged(): void {
    if (document.activeElement?.id !== this.customId!) {
      this.showControls = false;
      this.setControlsActive(false);
    }
  }

  get infoIcon(): string {
    return require("/src/assets/svg/svg-home/10-info.svg");
  }

  get addFavIcon(): string {
    return require("/src/assets/svg/svg-home/11-add-fav.svg");
  }

  get favIcon(): string {
    return require("/src/assets/svg/svg-home/12-fav.svg");
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }

  handlePlay(): void {
    //only Movie or TV Show Episode will have a play button enabled since a Tv Show must select an episode to view
    this.setActiveVodItem(this.vod as Episode);
    this.updateClosePlayer(true);
  }

  handleInfo(): void {
    this.setActiveEpisode(this.vod as Episode);
    this.setShowEpisodeInfoModal(true);
  }

  beforeDestroy(): void {
    if (this.card) {
      this.card.removeEventListener("focusout", this.focusChanged);
    }
  }
}
